/* tslint:disable:indent */
export class BoutonMessages {
  public abandonner = 'boutons.abandonner';
  public ajouterPj = 'boutons.ajouter_pj';
  public annuler = 'boutons.annuler';
  public exportTableau = 'boutons.export_tableau';
  public filtrer = 'boutons.filtrer';
  public nouvelleDemande = 'boutons.nouvelle_demande';
  public precedent = 'boutons.precedent';
  public renvoyer = 'boutons.renvoyer';
  public signaler = 'boutons.signaler';
  public soumettreDemande = 'boutons.soumettre_demande';
  public continuer = 'boutons.continuer'
  public suivant = 'boutons.suivant';
  public validerForm = 'boutons.valider_form';
  public validerStep = 'boutons.valider_step';
  public envoyer = 'boutons.envoyer'
  public creerAP = 'boutons.creerAP';
  public demarrerDemande = 'boutons.demarrerDemande';
  public telecharger = 'boutons.telecharger';
  public supprimer = 'boutons.supprimer';
  public modifier = 'boutons.modifier';
  public dupliquer_avis = 'boutons.dupliquer_avis';
  public creer_avis = 'boutons.creer_avis';
  public enregistrer = 'boutons.enregistrer';
  public ajouter_section = 'boutons.ajouter_section';
  public lie_avis = 'boutons.lie_avis';

  constructor() {
  }
}
